import { ResponsiveContainer } from "recharts";

function GraficoComponent({ children, title, col }: any) {
  return (
    <div className={`graficoDashboardDefaultDiv ${col}`}>
      <p className='graficoDashboardDefaultP'>{title}</p>
      <ResponsiveContainer width="90%" height="100%">
        {children}
      </ResponsiveContainer>
    </div>
  );
}

export default GraficoComponent;